const g:any = window[ENV.projectName] = window[ENV.projectName] || {};

import { WebGL1Renderer    } from 'three/src/renderers/WebGL1Renderer'   ;
import { PerspectiveCamera } from 'three/src/cameras/PerspectiveCamera' ;
import { Color             } from 'three/src/math/Color'                ;
import { Scene             } from 'three/src/scenes/Scene'              ;
import { Texture           } from 'three/src/textures/Texture'          ;
import { TextureLoader     } from 'three/src/loaders/TextureLoader'     ;
import { Object3D          } from 'three/src/core/Object3D'             ;
import { Mesh              } from 'three/src/objects/Mesh'              ;
import { Material          } from 'three/src/materials/Material'        ;
import { LinearFilter      } from 'three/src/constants'                 ;

import { WEBGL } from 'three/examples/jsm/WebGL';

export default class WebGLBase {
  public container!: HTMLElement;
  public isNoWebGL!: boolean;
  protected canvas!: HTMLCanvasElement;

  protected devicePixelRatio: number = 1;

  protected renderer!: WebGL1Renderer;
  protected scene!: Scene;
  protected camera!: PerspectiveCamera;

  protected width: number = 0;
  protected height: number = 0;
  protected startTime: number = 0;
  protected time: number = 0;

  protected animationId: number = 0;
  protected isDisposed: boolean = false;

  constructor(container: HTMLElement, canvas: HTMLCanvasElement) {
    this.container = container;
    this.canvas = canvas;
  }

  public static async initImgTexture(imgSrc: string): Promise<Texture>  {
    return new Promise((resolve)=> {
      const loader: TextureLoader = new TextureLoader();
      // loader.crossOrigin = 'https://0.0.0.0:50000';
      loader.load(imgSrc, (texture: Texture)=> {
        texture.generateMipmaps = false;
        texture.minFilter = LinearFilter;
        texture.magFilter = LinearFilter;
        texture.needsUpdate = true;
        resolve(texture);
      });
    });
  }

  public async init(): Promise<any> {
    this.isNoWebGL = g.isIE11 || !WEBGL.isWebGLAvailable();

    if(this.isNoWebGL || g.isIE11) {
      throw Error('not support webgl');
    }

    await this.initWebGL();
  }

  protected async initContents(): Promise<any> {}

  protected beforeRenderContents() {}
  protected afterRenderContents() {}



  public initDatGUI(datGUI) {}

  public setPixelRatio(devicePixelRatio: number, render: boolean = false) {
    this.devicePixelRatio = devicePixelRatio;
    this.renderer.setPixelRatio(this.devicePixelRatio);
    if(render) this.onResize();
  }

  protected async initWebGL(): Promise<any> {
    console.log('init webgl');

    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;

    this.devicePixelRatio = window.devicePixelRatio;

    // renderer
    this.renderer = new WebGL1Renderer({
      canvas: this.canvas,
      // antialias: true,
      alpha: true
    });
    this.renderer.setPixelRatio(this.devicePixelRatio);
    this.renderer.setClearColor(new Color(0, 0, 0), 0);

    // camera
    this.camera = new PerspectiveCamera(45, 1, 1, 1000000);
    this.camera.position.z = 500;
    this.camera.lookAt(0, 0, 0);
    // this.camera.matrixAutoUpdate = false;

    // scene
    this.scene = new Scene();
    this.scene.matrixAutoUpdate = false;
    this.scene.matrixWorldNeedsUpdate = true;

    this.update = this.update.bind(this);

    await this.initContents();
    console.log('init contents');

  }

  protected update() {
    this.animationId = requestAnimationFrame(this.update);
    this.render();
  }

  public startLoop() {
    if(this.isNoWebGL || this.isDisposed) return;
    this.stop();
    this.start();
    this.update();
  }

  public start() {
    this.startTime = new Date().getTime()
  }

  public stop() {
    if(this.animationId) cancelAnimationFrame(this.animationId);
  }

  public render() {
    if(this.isNoWebGL || this.isDisposed) return;

    this.time = new Date().getTime() - this.startTime;

    this.beforeRenderContents();
    this.renderer.render(this.scene, this.camera);
    this.afterRenderContents();
  }

  public onResize(width: number = 0, height: number = 0) {
    if(this.isNoWebGL || this.isDisposed) return;

    this.width = width || this.container.offsetWidth || 1;
    this.height = height || this.container.offsetHeight || 1;

    this.camera.aspect = this.width / this.height;
    const cameraPosZ: number = (this.height / 2) / Math.tan((this.camera.fov * Math.PI / 180) / 2);
    this.camera.position.z = cameraPosZ;
    this.camera.updateMatrix();
    this.camera.updateProjectionMatrix();

    this.renderer.setSize(this.width, this.height);

    this.onResizeContents();

    this.render();
  }

  protected onResizeContents() {
  }

  public disposeObject3D(object: Object3D | Mesh) {
    if(object.children && object.children.length > 0) {
      let child: Object3D | Mesh;
      while(child = object.children[0]) {
        this.disposeObject3D(child);
        object.remove(child);
      }
    }

    if(!(object instanceof Mesh)) return;

    object.geometry.dispose();

    if(object.material instanceof Material) {
      object.material.dispose();
    }
  }

  public dispose() {
    if(this.isDisposed) return;

    this.stop();

    this.scene.dispose();
    delete this.scene;

    delete this.camera;

    this.renderer.dispose();
    delete this.renderer;

    this.isDisposed = true;
  }
}
